import store from "../../store";
import { DATAS } from "@/datas";
//import API_ENTRIES from "@/datas/authservice/entries.js";
// import API_ENTRIES from "@/datas/authservice/multi_entries.js";
import API_ENTRIES from "@/datas/authservice/multi_entries_channel.js";
import API_SHOPLUSE_ENTRIES from "@/datas/authservice/shoplus-entries.js";

/**
 * /router/index.js
 * store 정보 세팅 및 네비게이션 가드 통합 관리
 */
export default class SetStoreInfo {
  /**
   * @param {*} router
   * @param {*} path
   * @param {*} appCode
   */
  constructor(router, path, appCode) {
    this.router = router;
    this.path = path;

    // console.log("SetStoreInfo", path, appCode, sessionStorage["shoplus_cert_appCode"]);
    this.appCode = this._getAppCode(appCode);
    // console.log("real appCode", this.appCode);

    // Initialize async (will be called by the consumer)
    this.initialized = this.initialize();
  }

  async initialize() {
    // ★★★ 최우선 공통 설정 ★★★
    await this.setStoreCommon();

    // 통합 네비게이션 가드 설정
    this.setupNavigationGuards();

    // 경로별 설정
    switch (this.path) {
      case "shoplus_service":
      case "shoplus_authservice":
        store.commit("SET_MALL_TYPE", "shoplus");
        this.setStoreShoplus();
        break;
      case "imweb":
        this.setStoreCafe24();
        store.commit("SET_MALL_TYPE", "imweb");
        break;
      default:
        this.setStoreCafe24();
        break;
    }

    // ★★★ 초기 로드 시 현재 라우트에 대한 인증/결제 체크 수행 ★★★
    // await this.handleRouteAuthentication(currentRoute, { name: null }, mockNext);
    // await this.performInitialRouteCheck();
  }

  /**
   * 통합 네비게이션 가드 설정
   */
  async setupNavigationGuards() {
    await this.performInitialRouteCheck();
    this.router.beforeEach(async (to, from, next) => {
      try {
        // 1. 앱코드 접근 제한 검사
        if (!this.checkAppCodeAccess(to, from, next)) {
          return; // 접근 제한으로 인해 라우팅이 중단된 경우
        }

        // 2. 경로별 인증 및 설정 처리
        await this.handleRouteAuthentication(to, from, next);
      } catch (error) {
        this.handleNavigationError(error, to, from, next);
      }
    });
  }

  /**
   * 앱코드 접근 제한 검사
   */
  checkAppCodeAccess(to, from, next) {
    // 로컬스토리지에서 appCode 읽기 (없으면 cert_product가 기본값)
    const currentAppCode = this.router.app.$store?.state?.appCode || "cert_product";

    if (to.meta && to.meta.appCode) {
      // 공통 메뉴는 모든 앱코드에서 접근 가능
      if (to.meta.appCode === "common") {
        return true;
      }

      // 앱코드가 일치하지 않으면 결제 관리 페이지 또는 이전 페이지로 이동
      if (currentAppCode !== to.meta.appCode) {
        console.log(`[접근 제한] 현재 앱(${currentAppCode})에서는 ${to.name} 메뉴(${to.meta.appCode})에 접근할 수 없습니다.`);

        // 이전 페이지가 있고, 해당 페이지의 메타 정보를 확인할 수 있는 경우
        if (from.matched && from.matched.length > 0) {
          const fromMeta = from.meta || {};

          // 이전 페이지도 접근 불가능한 페이지인 경우 (앱코드가 다르거나, 공통 페이지가 아닌 경우)
          if (fromMeta.appCode && fromMeta.appCode !== "common" && fromMeta.appCode !== currentAppCode) {
            // 결제관리 페이지로 이동
            // console.log("app_code check move to payment page");
            const mallId = to.params.mall_id || from.params.mall_id;
            next({ path: `/authservice/${mallId}/payment` });
          } else {
            // 이전 페이지가 접근 가능한 페이지라면 뒤로 돌려보냄
            next(false);
          }
        } else {
          // 이전 페이지 정보가 없는 경우에는 결제관리 페이지로 이동
          // console.log("mall_id check move to payment page");
          const mallId = to.params.mall_id;
          if (mallId) {
            next({ path: `/authservice/${mallId}/payment` });
          } else {
            // mall_id가 없는 경우 홈으로 이동
            next({ path: "/" });
          }
        }
        return false; // 접근 제한으로 라우팅 중단
      }
    }

    return true; // 접근 허용
  }

  /**
   * 경로별 인증 및 설정 처리 (이중 처리 완전 방지)
   */
  async handleRouteAuthentication(to, from, next) {
    // ★★★ 최우선: 공통 설정 한번에 처리 ★★★
    await this.setStoreCommon();

    // Shoplus 경로 처리
    if (this.path === "shoplus_service" || this.path === "shoplus_authservice") {
      await this._setShoplusAuth();
      next();
      return;
    }

    // CommonLogin 및 기타 imweb 전용 라우트 처리
    const imwebOnlyRoutes = ["Information", "CommonLogin", "MemberLogin", "MemberJoin", "MemberFindPassword", "MemberResetPassword"];
    if (imwebOnlyRoutes.includes(to.name)) {
      // mallType은 이미 imweb으로 설정됨
      next();
      return;
    }

    // 레이아웃 없는 페이지 처리 - 인증 불필요 페이지는 바로 통과
    if (to.meta && to.meta.hideLayout) {
      // requireAuth: false인 경우 인증 체크 건너뛰기
      if (to.meta.requireAuth === false) {
        console.log("Auth not required page detected, skipping authentication checks");
        next();
        return;
      }
      console.log("Layout-less page detected, skipping additional authentication checks");
      next();
      return;
    }

    // imweb mallType이고 로그인이 필요한 경우에만 API 처리
    if (store.state.mallType === "imweb") {
      // 로그인 여부 체크 - access_token이 있는지 확인
      const hasLogin = this._checkImwebLogin();

      if (!hasLogin) {
        // 로그인되지 않은 경우 CommonLogin으로 리다이렉트
        console.log("Imweb user not logged in, redirecting to login");
        next({
          name: "CommonLogin",
          query: { redirect: to.fullPath },
        });
        return;
      }
    }

    // ★★★ setStoreCommon 처리 후 필수 값들 검증만 수행 ★★★
    if (!store.state.mallId) {
      throw new Error("requireAuth");
    }

    if (!store.state.accessToken) {
      throw new Error("requireAuth");
    }

    if (!store.state.shopNo) {
      // 최후의 fallback
      store.state.shopNo = "1";
      store.commit("CHANGE_SHOPNO", "1");
    }

    if (!store.state.mode) {
      throw new Error("requirePayment");
    }

    //*
    if (
      to.matched.some(
        (route) =>
          route.meta.requireModes === undefined ||
          (Array.isArray(route.meta.requireModes) && route.meta.requireModes.includes(store.state.mode)),
      )
    ) {
      next();
    } else {
      console.log("requirePayment error", to.name, store.state.mode);
      throw new Error("requirePayment");
    }
  }

  /**
   * 네비게이션 에러 처리
   */
  handleNavigationError(error, to, from, next) {
    switch (error.message) {
      case "requireAuth":
        // requireAuth: false인 페이지는 인증 에러 무시하고 통과
        if (to.meta && to.meta.requireAuth === false) {
          console.log("Auth not required page, bypassing requireAuth error");
          next();
          return;
        }

        if (this.path === "shoplus_service" || this.path === "shoplus_authservice") {
          store.state.mallId = null;
          window.location.href = "/shoplus_service";
        } else if (store.state.mallType === "imweb") {
          console.log("imweb requireAuth error - redirecting to login", to, to.meta.requireAuth);
          const imwebPaths = [
            "/authservice/login",
            "/authservice/join",
            "/authservice/find-password",
            "/authservice/reset-password",
            "/intro",
          ];
          if (imwebPaths.includes(window.location.pathname)) {
            next();
            return;
          } else {
            // CommonLogin으로 리다이렉트
            next({
              name: "CommonLogin",
              query: { redirect: to.fullPath },
            });
          }
        } else {
          window.location.href = `https://${store.state.mallId}.cafe24.com/disp/admin/shop1/myapps/list`;
        }
        break;
      case "requirePayment":
        if (store.state.mallId) {
          next({ path: `/authservice/${store.state.mallId}/payment` });
        } else {
          next({ path: "/" });
        }
        break;
      default:
        next();
        break;
    }
  }

  /**
   * 초기 로드 시 현재 라우트에 대한 인증/결제 체크 수행
   */
  async performInitialRouteCheck() {
    // 현재 라우트 정보 가져오기
    const currentRoute = this.router.currentRoute;
    if (!currentRoute) {
      return;
    }

    try {
      // 가상의 next 함수 생성 (실제 라우팅은 하지 않고 체크만 수행)
      const mockNext = (routeOrError) => {
        if (routeOrError && typeof routeOrError === "object" && routeOrError.path) {
          // 리다이렉트가 필요한 경우 실제 라우팅 수행
          console.log("Initial route check requires redirect to:", routeOrError.path);
          this.router.push(routeOrError);
        } else if (routeOrError === false) {
          // 접근 거부
          console.log("Initial route check: Access denied");
        } else {
          // 정상 통과
          console.log("Initial route check: Access granted");
        }
      };

      // 1. 앱코드 접근 제한 검사
      if (!this.checkAppCodeAccess(currentRoute, { name: null }, mockNext)) {
        return; // 접근 제한으로 인해 체크 중단
      }

      // 2. 인증 및 설정 처리
      await this.handleRouteAuthentication(currentRoute, { name: null }, mockNext);
    } catch (error) {
      // 에러 발생 시 handleNavigationError와 동일한 처리
      const mockNext = (routeOrError) => {
        if (routeOrError && typeof routeOrError === "object" && routeOrError.path) {
          console.log("Initial route error handling requires redirect to:", routeOrError.path);
          this.router.push(routeOrError);
        } else if (routeOrError && typeof routeOrError === "object" && routeOrError.name) {
          console.log("Initial route error handling requires redirect to route:", routeOrError.name);
          this.router.push(routeOrError);
        }
      };
      this.handleNavigationError(error, currentRoute, { name: null }, mockNext);
    }
  }

  /**
   * 최우선 공통 설정 (기존 함수들 활용)
   */
  async setStoreCommon() {
    // 1. appCode 설정
    if (!store.state.appCode) {
      store.commit("SET_APP_CODE", this.appCode);
    }

    // 1.5. entries 설정 (mapping.js 에러 방지)
    if (!store.state.entries || !Array.isArray(store.state.entries)) {
      if (this.path === "shoplus_service" || this.path === "shoplus_authservice") {
        store.commit("SET_ENTRIES", API_SHOPLUSE_ENTRIES);
      } else {
        store.commit("SET_ENTRIES", API_ENTRIES);
      }
    }

    // 2. ★★★ URL에서 직접 파라미터 추출 ★★★
    const urlParams = new URLSearchParams(window.location.search);
    const pathSegments = window.location.pathname.split("/");

    // 3. ★★★ mallType 최우선 설정 ★★★
    const imwebPaths = ["/authservice/login", "/authservice/join", "/authservice/find-password", "/authservice/reset-password", "/intro"];
    const mType = urlParams.get("mType");
    if (mType) {
      store.commit("SET_MALL_TYPE", mType);
      if (mType === "imweb" && imwebPaths.includes(window.location.pathname)) {
        return;
      }
    } else {
      // imweb 전용 경로들에서는 imweb으로 설정

      if (imwebPaths.includes(window.location.pathname)) {
        store.commit("SET_MALL_TYPE", "imweb");
        return;
      } else {
        // 세션에서 복구
        const sessionMallType = sessionStorage.getItem(`shoplus_cert_mallType`);
        if (sessionMallType) {
          store.commit("SET_MALL_TYPE", sessionMallType);
        } else if (this.path === "imweb") {
          // path가 imweb인 경우 즉시 설정
          store.commit("SET_MALL_TYPE", "imweb");
        } else {
          store.commit("SET_MALL_TYPE", "mall");
        }
      }
    }

    // 4. ★★★ mallId 최우선 설정 ★★★
    if (!store.state.mallId) {
      // URL 파라미터에서 mall_id 추출
      let mall_id = urlParams.get("mall_id");

      // URL path에서 mall_id 추출 (예: /authservice/testmall/...)
      if (!mall_id) {
        const authserviceIndex = pathSegments.findIndex((segment) => segment === "authservice");
        if (authserviceIndex !== -1 && pathSegments[authserviceIndex + 1]) {
          mall_id = pathSegments[authserviceIndex + 1];
        }
      }

      // 세션에서 복구
      if (!mall_id) {
        mall_id = sessionStorage.getItem("current_mall_id");
      }

      if (mall_id) {
        store.commit("SET_MALL_ID", mall_id);
        // 세션에 저장
        sessionStorage.setItem("current_mall_id", mall_id);
      }
    }

    // 5. ★★★ access_token 최우선 설정 ★★★
    if (!store.state.accessToken) {
      // URL 파라미터에서 access_token 추출
      let access_token = urlParams.get("access_token");

      // mallType이 imweb인 경우 imweb 전용 토큰 확인
      if (store.state.mallType === "imweb") {
        access_token = localStorage.getItem("imweb_cert_access_token");
      }

      // 로컬 스토리지에서 확인 (cafe24용)
      if (!access_token && store.state.mallId) {
        access_token = localStorage.getItem(`${store.state.appCode}_${store.state.mallId}_accessToken`);
      }

      // 세션 스토리지에서 확인 (백업)
      if (!access_token && store.state.mallId) {
        access_token = sessionStorage.getItem(`${store.state.appCode}_${store.state.mallId}_accessToken`);
      }

      if (access_token) {
        await store.dispatch("SET_ACCESS_TOKEN", {
          access_token: access_token,
        });
      }
    }

    // 6. ★★★ shopNo 최우선 설정 ★★★
    if (!store.state.shopNo && store.state.mallId && store.state.mallType && !this._isLayoutlessPage()) {
      // console.log("0-0-0- setSToreCommon check2", store.state.shopNo, store.state.mallId, store.state.mallType);
      try {
        // URL 파라미터에서 shop_no 확인
        let shop_no = urlParams.get("shop_no");

        // 로컬 스토리지에서 확인
        if (!shop_no) {
          shop_no = localStorage.getItem(`${store.state.appCode}_${store.state.mallId}_shop_no`);
        }

        // API 호출로 가져오기 (imweb의 경우)
        if (!shop_no && store.state.mallType === "imweb") {
          shop_no = await this._getImwebDefaultShopNo();
        }

        // 기본값 설정
        if (!shop_no) {
          // console.log("[DEfault set", shop_no);
          shop_no = "1";
        }

        if (shop_no) {
          store.state.shopNo = shop_no;
          store.commit("CHANGE_SHOPNO", shop_no);
          // 로컬 스토리지에 저장
          localStorage.setItem(`${store.state.appCode}_${store.state.mallId}_shop_no`, shop_no);
        }
      } catch (error) {
        // console.warn("Early shopNo setting failed:", error);
        // fallback으로 기본값 설정
        store.state.shopNo = "1";
        store.commit("CHANGE_SHOPNO", "1");
      }
    }

    // 레이아웃 없는 페이지에서는 SET_CERT_PRODUCTS_VERSION 호출하지 않음
    if (store.state.mode === null && store.state.shopNo && !this._isLayoutlessPage()) {
      await store.dispatch("SET_CERT_PRODUCTS_VERSION");
    }

    // 디버깅 로그
    // console.log("setStoreCommon completed:", {
    //   mallId: store.state.mallId,
    //   mallType: store.state.mallType,
    //   shopNo: store.state.shopNo,
    //   accessToken: store.state.accessToken ? "SET" : "NULL",
    // });
  }

  /**
   * CAFE24 store 설정 (beforeEach 로직 제거됨 - 통합 처리)
   */
  setStoreCafe24() {
    if (!store.state.entries || !Array.isArray(store.state.entries)) {
      store.commit("SET_ENTRIES", API_ENTRIES);
    }
  }

  /**
   * Shoplus store 설정 (beforeEach 로직 제거됨 - 통합 처리)
   */
  setStoreShoplus() {
    if (!store.state.entries || !Array.isArray(store.state.entries)) {
      store.commit("SET_ENTRIES", API_SHOPLUSE_ENTRIES);
    }
  }

  /**
   * 효율적으로 appCode를 가져오는 헬퍼 메소드
   */
  _getAppCode(passedAppCode) {
    if (passedAppCode) {
      return passedAppCode;
    }

    // 세션 스토리지에서 appCode 조회
    const sessionAppCode = sessionStorage.getItem(`shoplus_cert_appCode`);
    if (sessionAppCode) {
      return sessionAppCode;
    }

    // 기본 appCode 반환
    return DATAS.ASA_APP_CODE;
  }

  /**
   * mall_id를 효율적으로 가져오는 헬퍼 메소드
   * @param {Object} to - 라우트 객체
   * @returns {String} 효율적으로 처리된 mall_id
   */
  _getMallId(to) {
    // 1. 쿼리 파라미터에서 mall_id 확인
    let mall_id = to.query.mall_id;

    // 2. 배열인 경우 첫번째 값 사용
    if (mall_id && Array.isArray(mall_id)) {
      return mall_id[0];
    }

    // 3. 쿼리 파라미터에 없으면 라우트 파라미터에서 확인
    if (!mall_id) {
      mall_id = to.params.mall_id;

      // mall_id가 결정되고 app_code가 있으면 해당 mall_id로 앱 코드 저장
      if (mall_id && to.query.app_code) {
        const appCodeValue = Array.isArray(to.query.app_code) ? to.query.app_code[0].toLowerCase() : to.query.app_code.toLowerCase();
        sessionStorage.setItem(`shoplus_cert_appCode`, appCodeValue);
      }
    }

    if (!mall_id) {
      mall_id = to.params.mall_id;
    }

    // 4. 세션 스토리지에서 확인
    if (!mall_id) {
      mall_id = sessionStorage.getItem("current_mall_id");
    }

    return mall_id;
  }

  /**
   * shop_no를 효율적으로 가져오는 헬퍼 메소드 (비동기)
   * @param {String} mall_id - 쇼핑몰 ID
   * @param {Object} to - 라우트 객체 (선택적)
   * @returns {Promise<String>} 매장 번호
   */
  async _getShopNo(mall_id, to = null) {
    // 1. URL 쿼리 파라미터에서 shop_no 확인 (있는 경우)
    if (to && to.query && to.query.shop_no) {
      const shopNo = to.query.shop_no;
      // localStorage에 저장
      localStorage.setItem(`${store.state.appCode}_${mall_id}_shop_no`, shopNo);
      return shopNo;
    }

    // 2. 로컬 스토리지에서 확인
    const cached_shop_no = localStorage.getItem(`${store.state.appCode}_${mall_id}_shop_no`);
    if (cached_shop_no) {
      return cached_shop_no;
    }

    // 3. mallType에 따른 기본값 결정
    const mallType = store.state.mallType;

    if (mallType === "imweb") {
      // imweb: shops API에서 default=T인 unit_code 조회
      try {
        const shops = await this._getImwebDefaultShopNo();
        if (shops) {
          // localStorage에 저장
          localStorage.setItem(`${store.state.appCode}_${mall_id}_shop_no`, shops);
          return shops;
        }
      } catch (error) {
        console.error("Failed to get imweb default shop_no:", error);
      }
      // fallback: 기본값 "1"
      return "1";
    } else {
      // cafe24 및 기타: 기본값 "1"
      return "1";
    }
  }

  /**
   * imweb 기본 shop_no를 shops API에서 조회
   * @returns {Promise<String>} default=T인 unit_code
   */
  async _getImwebDefaultShopNo() {
    // console.log("get set store shop_list");
    try {
      // access_token이 설정되어 있는지 확인
      if (!store.state.accessToken) {
        console.warn("Access token not available for shops API call");
        return null;
      }

      // shops API 호출 (비동기)
      const M = await import("@/libs/mapping.js");
      const shops = await M.default.api(M.default.entry("/get/shops"));

      if (shops && Array.isArray(shops)) {
        // default가 T인 shop 찾기
        const defaultShop = shops.find((shop) => shop.default === "T");
        if (defaultShop && defaultShop.shop_no) {
          return defaultShop.shop_no;
        }
      }
    } catch (error) {
      console.error("Error fetching shops for imweb default shop_no:", error);
      // 인증 에러인 경우 별도 처리
      if (error.response && error.response.status === 401) {
        console.warn("Authentication failed for shops API - using fallback shop_no");
      }
    }
    return null;
  }

  /**
   * access token을 효율적으로 가져오는 헬퍼 메소드
   * @param {Object} to - 라우트 객체
   * @returns {String} 액세스 토큰
   */
  _getAccessToken(to) {
    // 1. 쿼리 파라미터에서 access_token 확인
    let access_token = to.query.access_token;

    // 2. 로컬 스토리지에서 확인
    if (!access_token && store.state.mallId) {
      access_token = localStorage.getItem(`${store.state.appCode}_${store.state.mallId}_accessToken`);
    }

    // 3. 세션 스토리지에서 확인 (백업)
    if (!access_token && store.state.mallId) {
      access_token = sessionStorage.getItem(`${store.state.appCode}_${store.state.mallId}_accessToken`);
    }

    return access_token;
  }

  /**
   * Shoplus 인증 정보를 설정하는 헬퍼 메소드
   */
  async _setShoplusAuth() {
    // 파트너 ID 설정
    const partnerId = sessionStorage.shoplusAuthServiceId;
    if (partnerId) {
      store.commit("SET_MALL_ID", partnerId);
    }

    // 액세스 토큰 설정
    const accessToken = sessionStorage.shoplusAuthServiceAccessToken;
    if (accessToken) {
      await store.dispatch("SET_SHOPLUS_ACCESS_TOKEN", accessToken);
    }

    // 리프레시 토큰 설정
    const refreshToken = localStorage.shoplusAuthServiceRefreshToken;
    if (refreshToken) {
      await store.dispatch("SET_SHOPLUS_REFRESH_TOKEN", refreshToken);
    }
  }

  /**
   * imweb 로그인 여부 체크
   * @returns {Boolean} 로그인 여부
   */
  _checkImwebLogin() {
    // imweb_cert_access_token이 로컬스토리지에 있는지 확인

    const accessToken = localStorage.getItem("imweb_cert_access_token");
    return !!accessToken;
  }

  /**
   * 현재 페이지가 레이아웃 없는 페이지인지 확인
   * @returns {Boolean} 레이아웃 없는 페이지 여부
   */
  _isLayoutlessPage() {
    const currentRoute = this.router.currentRoute;

    // 1. router 정보가 있는 경우 - meta.hideLayout 우선 확인
    if (currentRoute && currentRoute.meta && currentRoute.meta.hideLayout === true) {
      return true;
    }

    // 2. router 정보를 가져오지 못하는 경우 - URL 기반으로 hideLayout 페이지 판단
    if (!currentRoute || !this.router) {
      const currentPath = window.location.pathname;
      const hideLayoutPaths = [
        "/intro",
        "/authservice/login",
        "/authservice/join",
        "/authservice/find-password",
        "/authservice/reset-password",
      ];

      // 정확한 경로 매칭
      if (hideLayoutPaths.includes(currentPath)) {
        return true;
      }
    }

    return false;
  }
}
